import { useDispatch, useSelector } from "react-redux";
import { Typography } from "@mui/material";
import PropTypes from "prop-types";

import messages from "../../../assets/locale/messages";
import Modal from "../../../components/Modal";
import BlockRedBgIcon from "../../../utils/Icons/BlockRedBg";
import { deactivateEmployeeRequest } from "../../../store/Employees/actions";

const DeactivateEmployeeModal = ({
  open,
  closeModal,
  employeeInfo
}) => {
  const dispatch = useDispatch();

  const lang = useSelector((state) => state.locale.lang);
  const { employees, shared } = messages[lang];

  const handleConfirmDeactivation = () => {
    dispatch(deactivateEmployeeRequest({ id: employeeInfo?.id }));
    closeModal();
  };

  return (
    <Modal
      open={open}
      handleConfirm={handleConfirmDeactivation}
      handleClose={closeModal}
      isContentText={false}
      content={
        <div className="deactivate-employee-container container d-flex flex-column justify-content-center align-items-center">
          <BlockRedBgIcon />
          <div className="deactivate-employee-content mt-2 d-flex flex-column justify-content-center align-items-center text-center">
            <Typography className="fsize-20 fweight-700">
              {`${employees.deactivateEmployee.content} "${employeeInfo.Name}" !`}
            </Typography>
            <Typography className="text-secondary fsize-14 mt-2 fweight-600">
              {employees.deactivateEmployee.confirmationContent}
            </Typography>
          </div>
        </div>
      }
      hasActions={true}
      confirmBtnTxt={shared.deactivate}
      cancelBtnTxt={shared.cancel}
      handleCancel={closeModal}
      showCloseIcon
      confirmBtnClass="danger-btn"
      maxWidth={"xs"}
    />
  );
};

DeactivateEmployeeModal.propTypes = {
  open: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  employeeInfo: PropTypes.object.isRequired
};

export default DeactivateEmployeeModal;
